import {PaginationParams, ResponseType, PaginationResponse} from '@/types'
import axios, {parseResponseData} from '@/axiosInstance'
import {captureException} from '@sentry/react'
import {AccessGroupNameEnum, AccessType, AccessTypeCategoryEnum} from '@/features/access-types/types'
import {z} from 'zod'

// get project data
export type HttpGetAccessTypesOptions = {
    params: PaginationParams & {
        specializationId?: string
        groupName?: AccessGroupNameEnum
        category?: AccessTypeCategoryEnum
        responseType?: ResponseType
        search?: string
    }
}

// Define response shape with pagination metadata
const HttpGetAccessTypesResponse = z.object({
    data: z.array(AccessType),
    meta: PaginationResponse
})
export type HttpGetAccessTypesResponse = z.infer<typeof HttpGetAccessTypesResponse>

export const httpGetAccessTypes = async ({params}: HttpGetAccessTypesOptions) => {
    const response = await axios.get(`access-types`, {params})
    return parseResponseData({
        responseData: response.data,
        onZodError: captureException,
        responseShape: HttpGetAccessTypesResponse
    })
}
